import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PieceJointe} from '../../../common/services/pieces-jointes/piece-jointe.model';
import {FilesUtils} from '@Services/common';
import {PiecejointeService} from '../../../common/services/pieces-jointes/piecejointe.service';
import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import {Dossiers, FileTypeEnum} from '../../../common/services';
import { MatDialog } from '@angular/material/dialog';
import {Subject, Subscription} from 'rxjs';
import {SnackBarDataModel, SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {ErrorUpload} from '../../../common/piece-jointe-uploader/error.interface';
import {SafeHtml} from '@angular/platform-browser';
import {PubSubService} from "@Common/core/services";

@Component({
  selector: 'app-pj-dossier',
  templateUrl: './pj-dossier.component.html',
  styleUrls: ['./pj-dossier.component.scss']
})
export class PjDossierComponent implements OnInit {
  @Input() dossier: Dossiers;
  @Input() placeHolder: SafeHtml;
  @Input() attached_file: PieceJointe;
  @Input() typeFile: FileTypeEnum = null;
  @Input() titleFile = 'Fiche ' ;
  @Input() displayModelFiles = false;

  @Output() onFinished: EventEmitter<PieceJointe> = new EventEmitter<PieceJointe>();

  @Output() onDeleted: EventEmitter<PieceJointe> = new EventEmitter<PieceJointe>();

  uploaderConnector: Subject<any> = new Subject();

  file_to_upload: PieceJointe = null;

  typeFileEnum = FileTypeEnum;

  subscriptions: Subscription[] = [];

  constructor(private dialog: MatDialog,
              private fileUtils: FilesUtils,
              private pubSubSvc: PubSubService,
              private snackSvc: SnackBarToastyService,
              private pieceJointeService: PiecejointeService) { }

  ngOnInit() {
  }

  /**
   * Exécution du toaster
   * @param msg
   * @param title
   * @param type
   */
  public toasty(msg: string, title: string = '', type: typeToast = typeToast.success) {
    const config: SnackBarDataModel = {
      title: title,
      message: msg,
      type: type,
      showClose: true
    };

    this.snackSvc.openSnackToasty(config);
  }

  /**
   * Traitement erreur
   */
  onError(error: ErrorUpload) {
   if (error) {
     // console.log('error ', error);
     this.file_to_upload = null;
     this.attached_file = null;
   }
  }

  /**
   * Les fichiers ont été uploadés, action à entreprendre
   * @param pjs
   */
  handleFilesUploaded(pjs: PieceJointe[]) {
    // console.log('files uploaded ', pjs);

    if (pjs && pjs.length > 0) {
      this.file_to_upload = null;
      this.attached_file = pjs[0];

      this.onFinished.emit(pjs[0]);

      this.toasty('Le fichier a bien été téléversé au dossier');
    }
  }

  /**
   * callback emitter de la fiche de poste sélectionnée à uploader au save (onSelected)
   * @param pj
   */
  onSelectedPj(pj: PieceJointe) {
    if (pj && this.dossier) {
      // console.log('onSelectedPjPoste ', pj);
      this.file_to_upload = pj;
      this.file_to_upload.dossier = this.dossier.id;
      this.uploaderConnector.next(this.file_to_upload);
    }
  }

  /**
   * Picto du fichier
   * @param pj
   */
  getPicto(pj) {
    return this.fileUtils.getPictoFromExtension(pj);
  }

  /**
   * Télécharge d'un PJ
   * @param $event
   * @param typeFile
   */
  onDownload($event, typeFile: FileTypeEnum) {
    if (this.attached_file) {
      this.pieceJointeService.download(this.attached_file);
    }
  }

  /**
   * Confirmation de suppression de PJ
   * @param pj
   * @param typeFile
   */
  public deletePJ(pj: PieceJointe, typeFile: FileTypeEnum) {
    const data = new DialogData();
    data.title = 'Confirmation de suppression de fichier';
    data.message = `Souhaitez vous supprimer la pièce jointe (${pj.name}) du dossier ? `;

    const dialogRef = this.dialog.open(DialogValidationComponent, {data: data});
    dialogRef.updatePosition({top: '40px'});
    this.subscriptions.push(dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.pieceJointeService.delete(pj).subscribe(() => {
          this.toasty(`La pièce jointe (${pj.name}) a bien été supprimé du dossier`);

          this.attached_file = null;
          this.file_to_upload = null;

          this.onDeleted.emit(pj);
        });
      }
    }));
  }
}
